var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8136_27986)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8705 1.23428C11.2134 1.23428 11.4915 1.5125 11.4915 1.8553C11.4915 2.19811 11.2134 2.47632 10.8705 2.47632H4.8524C2.7757 2.47632 1.43346 3.90386 1.43346 6.1147V12.8068C1.43346 15.0467 2.7434 16.4378 4.8524 16.4378H11.9768C14.0535 16.4378 15.3957 15.0128 15.3957 12.8068V6.97834C15.3957 6.63554 15.674 6.35732 16.0167 6.35732C16.3596 6.35732 16.6378 6.63554 16.6378 6.97834V12.8068C16.6378 15.7216 14.7648 17.6799 11.9768 17.6799H4.8524C2.06442 17.6799 0.191406 15.7216 0.191406 12.8068V6.1147C0.191406 3.19588 2.06442 1.23428 4.8524 1.23428H10.8705ZM15.069 0.536987C16.2896 0.536987 17.2815 1.52897 17.2815 2.74949C17.2815 3.97001 16.2896 4.96282 15.069 4.96282C13.8493 4.96282 12.8565 3.97001 12.8565 2.74949C12.8565 1.52897 13.8493 0.536987 15.069 0.536987ZM15.069 1.77903C14.5341 1.77903 14.0985 2.21375 14.0985 2.74949C14.0985 3.2844 14.5341 3.72077 15.069 3.72077C15.6039 3.72077 16.0395 3.2844 16.0395 2.74949C16.0395 2.21375 15.6039 1.77903 15.069 1.77903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87322 11.7908L6.66568 13.0414L3.56055 9.93632L6.66568 6.83118L7.87322 8.08185L6.01877 9.93632L7.87322 11.7908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9103 9.93632L10.8052 13.0414L9.59766 11.7908L11.4521 9.93632L9.59766 8.08185L10.8052 6.83118L13.9103 9.93632Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8136_27986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsIcon);
export default __webpack_public_path__ + "static/media/logs-icon.64408893713660209b976820308fa374.svg";
export { ForwardRef as ReactComponent };